import { CACHE_QUERY_PARAM } from "constants/serviceWorker";
import { ServiceWorkerHelper } from "./helper";

export interface RequestServiceWorkerProps {
  event: FetchEvent;
  swOnlineStatus: boolean;
}
export type ChangedResponseData = {
  response: Response | undefined;
  data: any;
  isPutToCache?: boolean;
};

export const ErrorResponse = new Response("", {
  status: 503,
  statusText: "Service Unavailable",
});

const EXCLUDE_PARAMS = ["cursor", "limit", CACHE_QUERY_PARAM];

abstract class BaseRequestServiceWorker {
  event: FetchEvent;
  swOnlineStatus: boolean;
  protected storeNameOfRequest: string = "";
  protected params: Record<string, any> = {};

  constructor(params: RequestServiceWorkerProps) {
    this.event = params.event;
    this.swOnlineStatus = params.swOnlineStatus;
    this.init();
  }

  init() {
    const result = this.parseParams(this.event.request.clone());
    this.storeNameOfRequest = result.storeNameOfRequest;
    this.params = result.params;
  }

  getParamForCustomResponse() {
    return {
      event: this.event,
      swOnlineStatus: this.swOnlineStatus,
      storeNameOfRequest: this.storeNameOfRequest,
      params: this.params,
    };
  }

  isCacheRequest() {
    const urlObj = new URL(this.event.request.url);

    return urlObj.searchParams.get(CACHE_QUERY_PARAM) === "true";
  }

  parseParams(request: Request) {
    const uri = request.url.replace(
      `${process.env.REACT_APP_API_HOST_URL || ""}`,
      ""
    );
    const params: any = {};
    const queryString = uri.split("?").pop();

    const apiPath = uri.split("?")[0];
    let storeNameOfRequest = apiPath;
    if (uri.includes("count-items")) {
      return { storeNameOfRequest, params: {} };
    }
    const storeName = ServiceWorkerHelper.convertPathAPIToStoreName(apiPath);
    if (storeName) {
      storeNameOfRequest = storeName;
    }

    if (queryString) {
      const getParams = ({
        result,
        key,
        value,
      }: {
        result: any;
        key: string;
        value: any;
      }) => {
        if (result[key]) {
          if (Array.isArray(result[key])) {
            result[key].push(value);
          } else {
            result[key] = [result[key], value];
          }
        } else {
          result[key] = value;
        }
      };
      const urlObj = new URL(decodeURIComponent(request.url));
      urlObj.searchParams.forEach((value, key) => {
        if (EXCLUDE_PARAMS.includes(key)) {
          return;
        }
        getParams({ result: params, key, value });
      });
    }

    return { storeNameOfRequest, params };
  }
  abstract changeResponseData(): Promise<Response>;
}

export default BaseRequestServiceWorker;
